import { connect } from 'react-redux'

import { getReceivingHelloBabyBox } from 'registry/reducers'
import { PresentIcon } from 'components/icons'
import { GOAL_STATES } from 'registry/constants'

import SetupGoal from './setup-goal'

const getText = ({ receivingHelloBabyBox, isHelloBabyBoxQualified }) => {
  if (receivingHelloBabyBox) {
    return `You're getting a Hello Baby Box!`
  } else if (isHelloBabyBoxQualified) {
    return `You've qualified for a Hello Baby Box!`
  } else {
    return 'How do I get a Hello Baby Box?'
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <PresentIcon alternate={ownProps.alternateIcon} />,
    text: getText({
      receivingHelloBabyBox: getReceivingHelloBabyBox(state),
      isHelloBabyBoxQualified: ownProps.state == GOAL_STATES.COMPLETE,
    }),
  }
}

export default connect(mapStateToProps)(SetupGoal)
